/* eslint-disable no-undef */

import BingMaps from "./bing-maps.js";
import { updateQueryString, getUrlVars, isMobileView } from "/Assets/js/utilities.js";
import { Bouncer } from "/Assets/libs/bouncer-es6.js";
import * as tomSelect from "/Assets/libs/TomSelect/tom-select.complete.js";

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".wtb-results")) {
        const whereToBuyResults = new WhereToBuyResults();
        window.whereToBuyResults = whereToBuyResults;
        whereToBuyResults.init();
    }
});

class WhereToBuyResults {
    constructor() {
        this.wtbResultsPg = null;
        this.loaderElement = null;
        this.wtbResultsForm = null;
        this.wtbResultsFormBtn = null;
        this.searchResultsHeader = null;
        this.partnerList = null;
        this.category = null;
        this.country = null;
        this.location = null;
        this.city = null;
        this.state = null;
        this.postalCode = null;
        this.distance = null;
        this.unitKm = null;
        this.isResultsPg = null;
        this.activeFilters = [];
    }

    init() {
        const self = this;
        this.wtbResultsPg = document.querySelector(".wtb-results");
        this.loaderElement = this.wtbResultsPg.querySelector("[data-loader]");
        this.wtbResultsForm = this.wtbResultsPg.querySelector("[data-wtb-form]");
        this.wtbResultsFormBtn = this.wtbResultsForm.querySelector(".btn-primary");
        this.searchResultsHeader = document.querySelector("[data-search-results-header]");
        this.isResultsPg = !!this.wtbResultsPg;

        const selects = document.querySelectorAll("[data-custom-select]");
        selects.forEach(select => {
            new tomSelect(select, {
                maxItems: 1,
                maxOptions: null,
                onChange: function (value) {
                    if (select.name === "country") {
                        self.countrySelectOnChange(value);
                    }
                }
            });
        });
        this.loaderElement.style.display = "block";
    }

    initializeResults() {
        this.bingMaps = new BingMaps();
        this.bingMaps.init();
        this.wtbSearch();
        this.setupFormValidation();
        this.bindEvents();
    }

    bindEvents() {
        const self = this;
        this.wtbResultsForm.addEventListener("submit", e => {
            e.preventDefault();
            var areValid = self.bouncer.validateAll();
            if (areValid.length === 0) {
                self.btnLoadingOn(self.wtbResultsFormBtn);
                self.loaderElement.style.display = "block";
                self.clearResults();
                self.wtbSearch();
            }
        }, false);

        const elements = document.querySelectorAll(".wtb-foldable-content .foldable-title");
        elements.forEach(el => {
            el.addEventListener("click", this.foldableTitleClickHandler.bind(this));
        });

        document.querySelectorAll(".clearFiltersBtn").forEach(el => {
            el.removeEventListener("click", this.clearFiltersClickHandler.bind(this));
            el.addEventListener("click", this.clearFiltersClickHandler.bind(this));
        });

        document.querySelectorAll(".capability-filters input").forEach(el => {
            el.removeEventListener("click", this.capabilityFiltersClickHandler.bind(this));
            el.addEventListener("click", this.capabilityFiltersClickHandler.bind(this));
        });

        this.updateContactLink();
    }

    countrySelectOnChange(value) {
        const countryElement = document.querySelector("select[name=country]");
        const isMilesCountry = value === "US" || value === "GB";
        const distanceInKmInput = countryElement.closest("form").querySelector("input[name=DistanceInKm]");
        if ((isMilesCountry && distanceInKmInput.value === "False") || (!isMilesCountry && distanceInKmInput.value === "True"))
            return;

        this.updateDistanceSelect(countryElement);
    }

    foldableTitleClickHandler(e) {
        e.preventDefault();
        e.stopPropagation();

        if (!isMobileView())
            return;

        const parentElement = e.target.closest(".wtb-foldable-content");
        parentElement.classList.toggle("open");
    }

    clearFiltersClickHandler(e) {
        e.preventDefault();

        document.querySelectorAll(".capability-filters input[type=checkbox]").forEach(el => {
            el.checked = false;
        });
        this.activeFilters = [];
        this.partnerList.filter();
        this.updatePaginationText(this.partnerList);
    }

    capabilityFiltersClickHandler(e) {
        const isChecked = e.target.checked;
        const value = e.target.value.toLowerCase();

        if (isChecked) {
            this.activeFilters.push(value);
        } else {
            this.activeFilters.splice(this.activeFilters.indexOf(value), 1);
        }

        this.partnerList.filter(item => {
            if (this.activeFilters.length > 0) {
                let hasCapability = false;
                this.activeFilters.forEach(cap => {
                    if (item.values().capabilities.indexOf(cap) > -1) {
                        hasCapability = true;
                    }
                });
                return hasCapability;
            }
            return true;
        });
    }

    wtbSearch() {
        const countrySelect = document.querySelector("select[name='country']");
        this.country = countrySelect.value;
        this.location = this.wtbResultsForm.querySelector("input[name='location']");

        if (this.location && this.location.value) {
            this.bingMaps.geocodeLocation(this.location.value, this.country, this.getWtbList.bind(this));
        } else {
            this.getWtbList(this.category, this.country);
        }
    }

    getWtbList(geocode, country) {
        if (typeof geocode === "object" && geocode !== null) {
            this.postalCode = geocode.postalCode;
            if (geocode.locality != null) {
                this.city = geocode.locality;
                this.state = (geocode.adminDistrict || "") + " " + (geocode.adminDistrict2 || "");
            } else if (geocode.adminDistrict2 != null) {
                this.city = "";
                this.state = (geocode.adminDistrict || "") + " " + (geocode.adminDistrict2 || "");
            } else {
                this.city = "";
                this.state = geocode.adminDistrict;
            }

            if (this.postalCode != null) {
                this.wtbLoadListItems(country, this.postalCode, null, null);
            } else {
                this.wtbLoadListItems(country, null, this.city, this.state);
            }
        } else if (geocode == "no location found") {
            this.updatePageTitle(0);
            this.btnLoadingOff(this.wtbResultsFormBtn);
            this.clearResults();
            this.loaderElement.style.display = "none";
        } else {
            this.wtbLoadListItems(country, null, null, null);
        }
    }

    wtbLoadListItems(country, pc, c, s) {
        this.category = this.getFormValue("productcategory");
        this.unitKm = this.getFormValue("DistanceInKm");
        this.distance = this.getFormValue("distance");
        this.location = this.getFormValue("location");
        this.city = c;
        this.state = s;
        this.postalCode = pc;

        if (typeof country != "undefined" && country.length > 0) {
            this.updateUrlParameter("Country", country);
        }

        if (typeof this.unitKm != "undefined" && this.unitKm.length > 0) {
            this.updateUrlParameter("DistanceInKm", this.unitKm);
        }

        if (typeof this.distance != "undefined" && this.distance.length > 0) {
            this.updateUrlParameter("Distance", this.distance);
        }

        if (typeof this.location != "undefined" && this.location.length > 0) {
            this.updateUrlParameter("location", this.location);
        }

        if (this.city != null && this.city.length > 0) {
            this.updateUrlParameter("city", this.city);
        }

        if (this.state != null && this.state.length > 0) {
            this.updateUrlParameter("state", this.state);
        }

        if (this.postalCode != null && this.postalCode.length > 0) {
            this.updateUrlParameter("postalCode", this.postalCode);
        }

        let queryString = this.buildQueryString({
            ProductCategory: this.category,
            Country: country,
            DistanceInKm: this.unitKm,
            Distance: this.distance,
            Location: this.location,
            City: this.city,
            State: this.state,
            PostalCode: this.postalCode
        });

        const url = window.loadPartnerListUrl + "?" + queryString;
        fetch(url)
            .then(response => response.json())
            .then(data => this.handleFetchSuccess(data))
            .catch(error => this.handleFetchError(error));
    }

    getFormValue(name) {
        const element = this.wtbResultsForm.querySelector(`input[name='${name}'], select[name='${name}']`);
        return element ? element.value : "";
    }

    buildQueryString(params) {
        return Object.keys(params)
            .filter(key => params[key] != null && params[key].length > 0)
            .map(key => `${key}=${params[key]}`)
            .join("&");
    }

    handleFetchSuccess(data) {
        document.querySelector("[data-wtb-results-list]").innerHTML = data.partialView;
        document.getElementById("wtbResults").classList.remove("hidden");

        const numResults = data.locations.length;
        this.updatePageTitle(numResults);

        if (numResults > 0) {
            this.bingMaps.loadPins(data.locations);
            this.initializePaging();
            this.bindInfoBoxEvents();
            this.toggleElementsVisibility(false);
        } else {
            this.bingMaps.clearPins();
            this.toggleElementsVisibility(true);

            if (this.category == "PlasmaConsumables" || this.category == "LaserConsumables") {
                document.querySelector(".wtb-foldable-content").classList.add("open");
            }
        }

        this.btnLoadingOff(this.wtbResultsFormBtn);
        this.loaderElement.style.display = "none";
    }

    handleFetchError(error) {
        console.error("Error fetching data:", error);
        this.btnLoadingOff(this.wtbResultsFormBtn);
        this.loaderElement.style.display = "none";
    }

    toggleElementsVisibility(hidden) {
        const elements = document.querySelectorAll(".capability-filters-cntnr, .result-summary-top, .result-summary-bottom, .dist-result-list, .foldable-title");
        elements.forEach(el => el.classList.toggle("hidden", hidden));
    }

    initializePaging() {
        const options = {
            valueNames: [{ attr: "data-capabilities", name: "capabilities" }],
            page: window.numberPartnersPerPage,
            pagination: [
                {
                    name: "paginationTop",
                    paginationClass: "paginationTop",
                    prev: true,
                    next: true,
                    nextBtnText: window.jsl10n.JsResources.Translations.Common.Next + '&nbsp;<i class="fas fa-chevron-right"></i>',
                    prevBtnText: '<i class="fas fa-chevron-left"></i>&nbsp;' + window.jsl10n.JsResources.Translations.Common.Prev
                },
                {
                    paginationClass: "paginationBottom",
                    prev: true,
                    next: true,
                    nextBtnText: window.jsl10n.JsResources.Translations.Common.Next + '&nbsp;<i class="fas fa-chevron-right"></i>',
                    prevBtnText: '<i class="fas fa-chevron-left"></i>&nbsp;' + window.jsl10n.JsResources.Translations.Common.Prev
                }
            ]
        };
        this.partnerList = new List("wtbResults", options);
        this.updatePaginationText(this.partnerList);

        this.partnerList.on("paginationChange", list => {
            this.updatePaginationText(list);
            this.bindInfoBoxEvents();
        });
        this.partnerList.on("filterComplete", list => {
            this.updatePaginationText(list);
            this.bindInfoBoxEvents();
        });
    }

    clearResults() {
        this.bingMaps.clearPins();
        document.querySelector("[data-wtb-results-list]").innerHTML = "";
        document.getElementById("wtbResults").classList.add("hidden");
    }

    btnLoadingOn(button) {
        const text = button.getAttribute("data-loading-text");
        if (text) {
            button.setAttribute("data-label-text", button.innerHTML);
            button.innerHTML = text;
        }
        button.disabled = true;
    }

    btnLoadingOff(button) {
        const text = button.getAttribute("data-label-text");
        if (text) {
            button.innerHTML = text;
        }
        button.disabled = false;
    }

    updateUrlParameter(key, value) {
        if (!window.history.replaceState) {
            return;
        }
        const curUrl = window.location.href.split("#")[0];
        const newUrl = updateQueryString(key, value, curUrl);
        window.history.replaceState({}, "Page:" + key, newUrl);
    }

    updatePageTitle(count) {
        const totalHitsCntnr = this.searchResultsHeader.querySelectorAll("[data-total-hits]");
        totalHitsCntnr.forEach(el => {
            el.textContent = count;
        });

        if (count > 0) {
            this.searchResultsHeader.querySelector("[data-search-results-header-text]").classList.remove("hidden");
            this.searchResultsHeader.querySelector("[data-search-noresults-header-text]").classList.add("hidden");
            this.searchResultsHeader.querySelector("[data-search-result-header-text]").classList.add("hidden");
        } else if (count == 1) {
            this.searchResultsHeader.querySelector("[data-search-result-header-text]").classList.remove("hidden");
            this.searchResultsHeader.querySelector("[data-search-results-header-text]").classList.add("hidden");
            this.searchResultsHeader.querySelector("[data-search-noresults-header-text]").classList.add("hidden");
        } else {
            this.searchResultsHeader.querySelector("[data-search-result-header-text]").classList.add("hidden");
            this.searchResultsHeader.querySelector("[data-search-results-header-text]").classList.add("hidden");
            this.searchResultsHeader.querySelector("[data-search-noresults-header-text]").classList.remove("hidden");
        }
    }

    updatePaginationText(list) {
        const totalItems = list.matchingItems.length;
        const numberPerPage = parseInt(list.page);
        let currentPage = 1;
        const paginationTop = document.querySelector(".paginationTop li.active a");
        if (paginationTop) {
            currentPage = parseInt(paginationTop.getAttribute("data-i"));
        }

        if (Number.isNaN(currentPage)) currentPage = 1;
        const startItem = (currentPage - 1) * numberPerPage + 1;
        let endItem = numberPerPage * currentPage;
        if (endItem > totalItems) endItem = totalItems;

        document.querySelector(".wtb-results [data-list-startitem]").textContent = startItem;
        document.querySelector(".wtb-results [data-list-enditem]").textContent = endItem;
        document.querySelector(".wtb-results [data-list-totalitems]").textContent = totalItems;
        document.querySelector(".resultsText").style.display = "block";
    }

    bindInfoBoxEvents() {
        document.querySelectorAll(".dist-result-list [data-show-info-window]").forEach(el => {
            el.removeEventListener("click", this.infoBoxClickHandler.bind(this));
            el.addEventListener("click", this.infoBoxClickHandler.bind(this));
        });
    }

    infoBoxClickHandler(e) {
        const self = this;
        e.preventDefault();
        const partnerId = e.target.getAttribute("data-show-info-window");
        self.bingMaps.infoBoxClick(partnerId);
        document.getElementById("bing-maps-container").scrollIntoView();
        return false;
    }

    getCategoryFromUrl() {
        let category = getUrlVars().category ? getUrlVars().category : getUrlVars().Category;
        category = !category ? getUrlVars().productcategory : category;
        return category;
    }

    updateContactLink() {
        const contactLink = document.querySelector('a[href*="where-to-buy/where-to-buy-contact-information"]');
        if (!contactLink) return;
        const category = this.getCategoryFromUrl();
        if (!category) return;
        const curUrl = contactLink.getAttribute("href");
        const newUrl = updateQueryString("category", category, curUrl);
        contactLink.setAttribute("href", newUrl);
    }

    updateDistanceSelect(element) {
        const value = element.value;
        const isMilesCountry = value === "US" || value === "GB";
        const distanceInKmInput = element.closest("form").querySelector("input[name=DistanceInKm]");

        const distanceGroup = element.closest("form").querySelector(".distance");
        if (!distanceGroup) return;

        const distanceElement = distanceGroup.querySelector("select");
        if (!distanceElement) return;

        const distanceText = isMilesCountry ? distanceElement.getAttribute("data-miles") : distanceElement.getAttribute("data-km");

        distanceElement.innerHTML = "";
        const distances = [50, 100, 300, 500, 1000];
        distances.forEach(item => {
            const optionElement = document.createElement("option");
            optionElement.value = item.toString();
            optionElement.text = `${item} ${distanceText}`;
            distanceElement.add(optionElement);
        });

        const tomselect = distanceElement.tomselect;
        if (tomselect) {
            tomselect.clear();
            tomselect.clearOptions();
            tomselect.sync();
            tomselect.setValue(50);
        }

        const distanceInKm = isMilesCountry ? "False" : "True";
        distanceInKmInput.value = distanceInKm;
    }

    setupFormValidation() {
        const self = this;
        let bouncer = new Bouncer("[data-validate-results]", {
            disableSubmit: true,
            messages: {
                missingValue: {
                    checkbox: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired,
                    radio: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired,
                    select: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired,
                    "select-multiple": window.jsl10n.JsResources.Translations.Common.ThisFieldRequired,
                    default: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired
                },
                patternMismatch: {
                    email: window.jsl10n.JsResources.Translations.Common.EnterValidEmailAddress,
                    number: window.jsl10n.JsResources.Translations.Common.EnterValidNumber,
                    default: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired
                }
            }
        });
        self.bouncer = bouncer;
    }
}